var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick Square 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Tick-Square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick-Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    opacity: 0.4,
    d: "M20.425 2.5H9.5875C5.35 2.5 2.5 5.475 2.5 9.9V20.1125C2.5 24.525 5.35 27.5 9.5875 27.5H20.425C24.6625 27.5 27.5 24.525 27.5 20.1125V9.9C27.5 5.475 24.6625 2.5 20.425 2.5Z",
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M13.5167 19.0601C13.2367 19.0601 12.9567 18.9538 12.7429 18.7401L9.77668 15.7738C9.34918 15.3463 9.34918 14.6538 9.77668 14.2276C10.2042 13.8001 10.8954 13.7988 11.3229 14.2263L13.5167 16.4201L18.6767 11.2601C19.1042 10.8326 19.7954 10.8326 20.2229 11.2601C20.6504 11.6876 20.6504 12.3801 20.2229 12.8076L14.2904 18.7401C14.0767 18.9538 13.7967 19.0601 13.5167 19.0601Z",
    fill: "#00C087"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick-green.7b5c6d4392c055aaf75377ffbd4d1d76.svg";
export { ForwardRef as ReactComponent };